<template>
    <div class="white_bg">

        <div style="padding: 24px 0 0 24px; font-size: 20px; font-style: italic;">
            {{ title }}
        </div>

        <div class="body clearfix" style="height: 100vh">
            <div class="fl leftSideBar white_bg h100p hiddenScrollbar" :style="'width: 22%; overflow-y:auto;'">
                <categorySidebar ref="categorySidebar" @changeCategory="onChangeCategory" @changeTag="onChangeFirstTag"/>
            </div>

            <div class="rightInfo white_bg centerRegion fr h100p hiddenScrollbar" :style="'width: 78%; overflow-y:auto;'" >

                <div class="inner" style="padding: 16px 18px 0 9px;">

                    <div class="">
                        <adModule version="4" :type="adTypeEnum.DATUM_INDEX.code" :itemCount="1"/>
                    </div>

                    <!--                    <div class="bgWhite roundBorder4 marginT12">-->
                    <!--                        <div class="inner padding12">-->
                    <!--                            <div>-->
                    <!--                                全部资料-->
                    <!--                            </div>-->

                    <!--                            <div class="marginT8 grid3column gridRowGap10 gridColumnGap10">-->
                    <!--                                <div class="marginB8 hand" @click="allDatum()">-->
                    <!--                                    <div>-->
                    <!--                                        <img class="w100p" :src="'datum/all_datum.png'" style="aspect-ratio: 1"/>-->
                    <!--                                    </div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <div class="secondaryTagsContainer paddingH4 paddingV12" v-if="activeFirstTag">
                        <span class="secondTagItem font12r14" v-for="secondTagItem in activeFirstTag.subList || []" :key="secondTagItem.id"
                              :title="secondTagItem.remark" @click="changeSecondTag(secondTagItem)">
                            {{ secondTagItem.title }}
                        </span>
                    </div>

                    <div class="thirdTagsContainer" v-if="activeSecondTag">
                        <span class="thirdTagItem font12r14" :class="{active : ThirdTagItem == activeThirdTag}"
                              v-for="ThirdTagItem in activeSecondTag.subList || []" :key="ThirdTagItem.id"
                              :title="ThirdTagItem.remark" @click="changeThirdTag(ThirdTagItem)">
                            {{ ThirdTagItem.title }}
                        </span>
                    </div>

                    <div class="datumList">
                        <div class="datumItem" v-for="dataItem in dataList" :key="dataItem.id"
                             @click="viewItem(dataItem)">
                            <div class="flexLayout">
                                <div style="width: 76px; margin-right: 6px;">
                                    <div class="imageArea roundBorder4 hiddenOverflow"
                                         style="width: 100%; height: 76px;">
                                        <!--                                        <img class="fullSpace roundBorder8" :src="dataItem.coverImg" alt=""/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_word_65x85.png" v-if="dataItem.datumType === 'WORD'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_pdf_65x85.png" v-if="dataItem.datumType === 'PDF'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_ppt_65x85.png" v-if="dataItem.datumType === 'PPT'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.datumType === 'IMAGE_TEXT'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.datumType === 'TEACHING_PLAN'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_audio_65x85.png" v-if="dataItem.datumType === 'MUSIC'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_video_65x85.png" v-if="dataItem.datumType === 'VIDEO'"/>-->
<!--                                        <img class="fullSpace" src="datum/file_icon_package_65x85.png" v-if="dataItem.datumType === 'ZIP'"/>-->
                                        <img class="fullSpace" :src="dataItem.coverImg || 'datum/default_cover_image.jpg'"/>
                                    </div>
                                </div>
                                <div class="flexItem">
                                    <div class="titleArea maxHeightTwoLine hiddenOverflow marginB12"
                                         style="line-height: 1.3em; /*height: 2.6em;*/ text-overflow: ellipsis">
                                        {{dataItem.title}}
                                        <span v-if="(isDebug || mode === 'professional') && dataItem.isPay" class="green">
                                            [已支付]
                                        </span>

                                    </div>
                                    <div class="alignR">
                                        <span class="datumTypeTag wordType" v-if="isDatumType(dataItem, 'WORD')">文档</span>
                                        <span class="datumTypeTag teachingPlanType" v-if="isDatumType(dataItem, 'TEACHING_PLAN')">教案</span>
                                        <span class="datumTypeTag coursewareType" v-if="isDatumType(dataItem, 'COURSE_WARE')">课件</span>
                                        <span class="datumTypeTag collectionType" v-if="isDatumType(dataItem, 'COLLECTION')">合集</span>
                                        <span class="datumTypeTag tableType" v-if="isDatumType(dataItem, 'TABLE')">表格</span>
                                        <span class="datumTypeTag posterType" v-if="isDatumType(dataItem, 'POSTER')">海报</span>
                                        <span class="datumTypeTag speakType" v-if="isDatumType(dataItem, 'SPEAK')">话术</span>
                                        <span class="datumTypeTag environmentCreativeType" v-if="isDatumType(dataItem, 'ATLAS')">环创</span>

                                    </div>
                                </div>
                            </div>

                            <div v-if="isDebug && dataItem.isPay" class="">
                                (已购买)
                            </div>
                        </div><!-- end .datumItem -->

                        <div class="paddingV16 alignCenter font14r colorCCC"
                             v-show="status==='ready' && pagination.current == pagination.totalPage"
                             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                            没有更多资料了
                        </div>

                    </div><!-- end .datumList -->

                    <div style="height: 30px;"></div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
// lib and modules
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import adModule from '@/components/ad/bannerModule4'
import categorySidebar  from "@/components/datum/categorySidebar";

// config and data
import appConfig from '@/appConfig';
import adTypeEnum from '@/components/ad/adTypeEnum';

// utils
import appHelper    from '@/util/appHelper';
import windowHelper from '@/util/windowHelper';
import arrayHelper from '@/util/arrayHelper';
import consoleHelper from "@util/consoleHelper";
import userUtil from "@comp/shixunApp/userUtil";
import categoryApi from "@api/category";
import datumApi from "@api/datum";

const config = {
    name : 'homePageDatumComp',
    title : '最近发现',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/datum/list',
            dataPath : 'data.rows',
            totalPath : 'data.totalCount',
            totalPagePath : 'data.totalPage'
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { categorySidebar, adModule},
    data(){
        return {
            title : config.title,
            description : config.description,
            pageKey: 'zllist',
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            height : 0,
            adTypeEnum : adTypeEnum,

            debug : consoleHelper.getDebugStatus(),

            searchInputbox : {
                column : 'title'
            },

            filters : {
                firstCategory : '',
                secondCategory : '',
                thirdCategory : '',
                tagList : '',
            },

            isDebug : consoleHelper.getDebugStatus(),

            mode : window.app.mode,
            userData : null,
            userInstance : null,

            categoryList : [],
            activeTagId : '',
            tagList : [],
            activeFirstCategory : null,
            activeFirstTag : null,
            activeSecondTag : null,
            activeThirdTag : null,

            appHelper
        }
    },
    methods:{

        loadTagList() {
            datumApi.getTagList((result) => {
                this.tagList = result.data.lengthwaysTagList;
                if (!this.activeFirstTag && this.tagList.length)
                {
                    if (this.activeTagId)  // 从前一个页面传递
                    {
                        this.activeFirstTag = arrayHelper.getItemByColumn(this.tagList, 'id', parseInt(this.activeTagId));
                    }
                    else {  // 默认选择第一个标签
                        // this.activeFirstTag = this.tagList[0];
                    }
                    this.activeFirstTag ? this.$refs.categorySidebar.setSelectedId(this.activeFirstTag.id)
                                        : null;
                }
            });
        },
        loadCategoryList() {
            categoryApi.loadList('DATUM', (result) => {
                this.categoryList = result;
            });
        },
        setContainerHeight() {
            let h = windowHelper.getHeight();
            this.height = h;
        },

        onChangeCategory(result) {

            // this.filters.firstCategory = result.firstCategory || '';
            // this.filters.secondCategory = result.secondCategory || '';
            // let tag = '';
            // result.firstCategory ? tag = result.firstCategory : null;
            // result.secondCategory ? tag = result.secondCategory : null;
            // this.filters.tagList = tag;

            let id = result.id;
            this.filters.firstCategory = id;
            this.filters.secondCategory = '';
            this.filters.thirdCategory = '';

            this.activeFirstCategory = this.findCategoryById(id);

            this.reloadDataList();
        },
        onChangeFirstTag(result) {

            if (result.id)
            {
                this.filters.tagList = result.id
            }
            else
            {
                this.filters.tagList = '';
            }

            this.activeFirstTag = this.findTagById(result.id);
            // this.activeSecondTag = this.activeThirdTag = null;

            // auto select secondary tag
            if (this.activeFirstTag && this.activeFirstTag.subList.length)
            {
                this.activeSecondTag = this.activeFirstTag.subList[0];
                this.filters.tagList = this.activeSecondTag.id;
                if (this.activeSecondTag.subList.length)
                {
                    this.activeThirdTag = this.activeSecondTag.subList[0];
                    this.filters.tagList = this.activeThirdTag.id;
                }
            }

            this.reloadDataList();
        },

        allDatum() {
            // this.filters.tagList = item.id;
            // this.reloadDataList();
            appHelper.goToPage('datumIndex');
        },

        changeSecondTag(item) {
            this.activeSecondTag = item;
            this.activeThirdTag = null;
            this.filters.tagList = item.id;

            // auto select third tag.
            if (this.activeSecondTag.subList.length)
            {
                this.activeThirdTag = this.activeSecondTag.subList[0];
                this.filters.tagList = this.activeThirdTag.id;
            }

            this.reloadDataList();
        },

        changeThirdTag(item) {

            this.activeThirdTag = item;
            this.filters.tagList = item.id;
            this.reloadDataList();
            // appHelper.goToPage('datumIndex', {
            //     tagId : item.id
            // });
        },

        findCategoryById(id) {
            return arrayHelper.getItemById(this.categoryList, id);
        },
        findTagById(id) {
            return arrayHelper.getItemById(this.tagList, id);
        },

        /**
         * fire on search action
         * @event   onSearch
         * @param   {String}    value
         */
        onSearch : function (value){
            // appHelper.redirect('/datum/search/' + value);
            this.filters.title = value;
            this.reloadDataList();
        },

        viewItem(dataItem) {
            appHelper.goToPage('datumDetail', {
                id : dataItem.id
            });
        },

        isDatumType(dataItem, type) {
            let datumType = dataItem.datumType || '';
            let datumTypeList = datumType.split(',');
            return arrayHelper.existElement(type, datumTypeList);
        }
    },
    mounted(){

        const me = this;

        this.loadTagList();
        // this.loadCategoryList();
        //
        // if (typeof(window) === 'object')
        // {
        //     window.addEventListener('resize', () => {
        //
        //         if (!me)
        //         {
        //             return;
        //         }
        //         me.setContainerHeight();
        //     });
        //     me.setContainerHeight();
        // }

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                this.userData = result;
                this.userInstance = userUtil.createUser(result);
            }
            else {
                this.setWechatShare();
            }
        });

    }
}
</script>
<style scoped lang="scss">
.bgFAFAFA {
    background-color: #FAFAFA;
}
.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}

.font-style{
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
}

.grey {
    color: hsla(219, 16%, 60%, 1);
}
.red {
    color: hsla(2, 100%, 61%, 1);
}
.icon-category{
    width: 53px;
    height: 16px;
}
.datumItem {
    padding: 8px 0;
}

.deleteLine {
    text-decoration: line-through;
}
.secondaryTagsContainer {
    .secondTagItem {
        margin-right: 20px;
    }
    .secondTagItem:last-child {
        margin-right: 0;
    }
}
.thirdTagsContainer {
    .thirdTagItem {
        display: inline-block;
        background: #f7f7f7;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        padding: 0 6px;
        margin-right: 8px;
        color: #181818;
    }
    .thirdTagItem:last-child {
        margin-right: 0;
    }
    .thirdTagItem.active {
        background: #181818;
        color: #f7f7f7;
    }
}
.datumTypeTag {
    display: inline-block;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 9px;
    color: white;
    background: #000;
    font-size: 12px;
}
.datumTypeTag.wordType {
    background: #FE5747;
}
.datumTypeTag.coursewareType {
    background: #FFCE00;
}
.datumTypeTag.teachingPlanType {
    background: #779F10;
}
.datumTypeTag.collectionType {
    background: #FD9903;
}
.datumTypeTag.environmentCreativeType {
    background: #00A9F7;
}
.datumTypeTag.speakType {
    background: #B3EE18;
}
.datumTypeTag.tableType {
    background: #077938;
}
.datumTypeTag.posterType {
    background: #EF6EF9;
}

</style>
